import ModelUtil from '@leverege/model-util';
import { FontModel } from '@leverege/ui-style-elements';
import { v4 } from '@leverege/base62-util';

/**
 * This is meant to help out and supply a common model
 * for Column Models. It supplies style options
 * for the value, as well as controls to
 * what to show when the value is null
 */
function create(type, extend) {
  return {
    id: v4(),
    type,
    header: {
      label: null,
      color: null,
      variant: null,
      font: FontModel.create(),
      justify: 'left',
      align: 'center',
      wrap: false,
      background: null
    },
    width: null,
    minWidth: null,
    maxWidth: null,
    cell: {
      color: null,
      variant: null,
      font: FontModel.create(),
      justify: 'right',
      align: 'center',
      wrap: false,
      emptyValue: null,
      background: null
    },
    ...extend
  };
}
export default {
  create,
  ...ModelUtil.createAllValue('visible'),
  ...ModelUtil.createAllValue('header/label', 'headerLabel'),
  ...ModelUtil.createAllValue('header/variant', 'headerVariant'),
  ...ModelUtil.createAllValue('header/color', 'headerColor'),
  ...ModelUtil.createAllValue('header/font', 'headerFont'),
  ...ModelUtil.createAllValue('header/justify', 'headerJustify'),
  ...ModelUtil.createAllValue('header/align', 'headerAlign'),
  ...ModelUtil.createAllValue('header/wrap', 'headerWrap'),
  ...ModelUtil.createAllValue('header/background', 'headerBackground'),
  ...ModelUtil.createAllValue('width', 'width'),
  ...ModelUtil.createAllValue('minWidth', 'minWidth'),
  ...ModelUtil.createAllValue('maxWidth', 'maxWidth'),
  ...ModelUtil.createAllValue('cell/emptyValue', 'emptyValue'),
  ...ModelUtil.createAllValue('cell/color', 'color'),
  ...ModelUtil.createAllValue('cell/variant', 'variant'),
  ...ModelUtil.createAllValue('cell/font', 'font'),
  ...ModelUtil.createAllValue('cell/justify', 'justify'),
  ...ModelUtil.createAllValue('cell/align', 'align'),
  ...ModelUtil.createAllValue('cell/wrap', 'wrap'),
  ...ModelUtil.createAllValue('cell/background', 'background')
};